import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";
import { StyleFunctionProps } from "@chakra-ui/styled-system";

const { definePartsStyle } = createMultiStyleConfigHelpers(radioAnatomy.keys);

const xl = defineStyle({
  w: "6",
  h: "6",
});

const sizes = {
  xl: definePartsStyle({ control: xl, label: defineStyle({ w: "full" }) }),
};

const variants = {
  solid: (props: StyleFunctionProps) => ({
    control: {
      borderColor: `${props.colorScheme}.800`,
      _checked: {
        background: `${props.colorScheme}.800`,
        borderColor: `${props.colorScheme}.800`,
        color: "white",
        _hover: {
          background: `${props.colorScheme}.900`,
          borderColor: `${props.colorScheme}.900`,
        },
      },
    },
  }),
  "th-outline": () => ({
    control: {
      borderColor: `th.gray4`,
      _checked: {
        background: "th.white",
        borderColor: `th.gray4`,
        color: "th.black",
        _before: {
          w: "8px",
          h: "8px",
        },
        _hover: {
          background: "th.white",
          borderColor: `th.gray4`,
          color: "th.black",
        },
      },
    },
  }),
  "th-outline-2": () => ({
    control: {
      borderColor: `th.cream4`,
      _checked: {
        background: "th.white",
        borderColor: `th.cream4`,
        color: "th.black",
        _before: {
          w: "16px",
          h: "16px",
        },
        _hover: {
          background: "th.white",
          borderColor: `th.cream4`,
          color: "th.black",
        },
      },
    },
    container: {
      alignItems: "flex-start",
    },
  }),
};

export const Radio = {
  variants,
  sizes,
};
